import { initializeApp } from 'firebase/app';
import { getFirestore, enableIndexedDbPersistence, CACHE_SIZE_UNLIMITED } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD8uGeTTHSUDNwWlRegLFwYLaKRHE3qw2U",
  authDomain: "anbpay-b6686.firebaseapp.com",
  projectId: "anbpay-b6686",
  storageBucket: "anbpay-b6686.firebasestorage.app",
  messagingSenderId: "175306588230",
  appId: "1:175306588230:web:ea1dd80aa66782c211ca47",
  measurementId: "G-TJ66VPZSVH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);

// Enable offline persistence for faster subsequent loads
// This caches data locally in IndexedDB
enableIndexedDbPersistence(db, {
  cacheSizeBytes: CACHE_SIZE_UNLIMITED
}).then(() => {
  console.log('[Firebase] Offline persistence enabled - data will be cached locally');
}).catch((err) => {
  if (err.code === 'failed-precondition') {
    // Multiple tabs open, persistence can only be enabled in one tab at a time
    console.log('[Firebase] Persistence failed: Multiple tabs open');
  } else if (err.code === 'unimplemented') {
    // Browser doesn't support persistence
    console.log('[Firebase] Persistence not supported in this browser');
  }
});

export default app;
